export default __webpack_public_path__ + "9d120faf58485c9725effcbb1b5de7bc.png";